const globalUrls = {
    LANDING_PAGE: '/',
    ABOUT_US: '/acerca-de',
    PRICING: '/precios',
};

export default globalUrls;
